import { Map } from 'immutable';

import ActionTypes, { NS } from './actionTypes';

export { NS };

const initialState = Map({
  error: false,
  success: false
});

export default function ForgotPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.RESET:
      return initialState;
    case ActionTypes.CLEAR_ERROR:
      return state.set('error', false);
    case ActionTypes.FORGOT_PASSWORD_SUCCESS:
      return state.set('success', true);
    case ActionTypes.FORGOT_PASSWORD_FAIL:
      return state.set('error', true);
    default:
      return state;
  }
}
